import { getElementOffset } from '../helpers/general';

document.querySelector('[data-scrollto]')?.addEventListener('click', (e) => {
  e.preventDefault();
  const target = document.querySelector(e.currentTarget.dataset.scrollto);
  console.log(target);
  window.scrollTo({
    top: getElementOffset(target).top,
    behavior: 'smooth',
  });
});
